const EXAMPLES = [
  {
    industry: 'Listing Promotion',
    icon: 'ri-building-line',
    image: 'https://readdy.ai/api/search-image?query=stunning%20modern%20luxury%20home%20exterior%20with%20large%20windows%20and%20manicured%20front%20lawn%20at%20golden%20hour%2C%20warm%20amber%20sunlight%20illuminating%20the%20facade%2C%20upscale%20residential%20architecture%2C%20professional%20real%20estate%20photography%2C%20clean%20simple%20background%2C%20no%20text%20overlay%2C%20photorealistic&width=600&height=400&seq=re-ex-listing-01&orientation=landscape',
    hook: 'This one won\'t last the weekend. Seriously.',
    headline: 'Just Listed: 4BR Modern Home in [Your City]. Schedule a Tour Today.',
    cta: 'Book a Showing',
    platform: 'Facebook',
    platformIcon: 'ri-facebook-circle-fill',
    result: '+380% more showing requests',
  },
  {
    industry: 'Seller Leads',
    icon: 'ri-key-line',
    image: 'https://readdy.ai/api/search-image?query=real%20estate%20agent%20handing%20over%20house%20keys%20to%20happy%20new%20homeowners%20in%20front%20of%20a%20beautiful%20suburban%20home%2C%20warm%20golden%20hour%20lighting%2C%20celebratory%20moment%2C%20professional%20photography%2C%20clean%20neighborhood%20background%2C%20no%20text%2C%20photorealistic&width=600&height=400&seq=re-ex-seller-01&orientation=landscape',
    hook: 'Homes in your neighborhood are selling fast. Is yours next?',
    headline: 'Find Out What Your Home Is Worth — Free, Instant Estimate.',
    cta: 'Get My Home Value',
    platform: 'Instagram',
    platformIcon: 'ri-instagram-fill',
    result: '3.4x more seller inquiries',
  },
  {
    industry: 'Buyer Leads',
    icon: 'ri-map-pin-line',
    image: 'https://readdy.ai/api/search-image?query=young%20couple%20happily%20reviewing%20floor%20plans%20and%20documents%20with%20a%20professional%20real%20estate%20agent%20at%20a%20modern%20office%20table%2C%20bright%20airy%20interior%2C%20warm%20natural%20lighting%2C%20professional%20consultation%20atmosphere%2C%20no%20text%2C%20photorealistic&width=600&height=400&seq=re-ex-buyer-01&orientation=landscape',
    hook: 'Stop scrolling Zillow. Start actually finding your home.',
    headline: 'Work With a Local Expert. See Listings Before They Hit the Market.',
    cta: 'Find My Dream Home',
    platform: 'Google Ads',
    platformIcon: 'ri-google-fill',
    result: '4.0x return on ad spend',
  },
];

export default function RealEstateExamples() {
  return (
    <section className="py-20 lg:py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-block text-sm font-semibold text-orange-500 uppercase tracking-widest mb-3">
            Real Ad Examples
          </span>
          <h2 className="text-3xl lg:text-4xl font-black text-stone-900 mb-4 leading-tight">
            Real Estate Ads That Fill Your Pipeline
          </h2>
          <p className="text-base text-stone-500 max-w-xl mx-auto">
            AdForge knows real estate. Here&apos;s what AI-generated{' '}
            <strong>real estate advertising</strong> looks like for listings, seller leads, and buyer leads.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-7">
          {EXAMPLES.map((ex) => (
            <article
              key={ex.industry}
              className="bg-white rounded-2xl border border-stone-100 overflow-hidden flex flex-col"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={ex.image}
                  alt={`${ex.industry} ad example`}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-3 left-3 flex items-center gap-1.5 bg-white/90 backdrop-blur-sm rounded-full px-3 py-1.5">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className={`${ex.platformIcon} text-sm text-stone-700`} />
                  </div>
                  <span className="text-xs font-semibold text-stone-700">{ex.platform}</span>
                </div>
                <div className="absolute top-3 right-3 flex items-center gap-1.5 bg-orange-500 rounded-full px-3 py-1.5">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className={`${ex.icon} text-xs text-white`} />
                  </div>
                  <span className="text-xs font-bold text-white">{ex.industry}</span>
                </div>
              </div>

              <div className="p-6 flex flex-col gap-3 flex-1">
                <div>
                  <p className="text-xs font-semibold text-stone-400 uppercase tracking-widest mb-1">Hook</p>
                  <p className="text-sm text-stone-700 italic leading-relaxed">&ldquo;{ex.hook}&rdquo;</p>
                </div>
                <div>
                  <p className="text-xs font-semibold text-stone-400 uppercase tracking-widest mb-1">Headline</p>
                  <p className="text-base font-bold text-stone-900 leading-snug">{ex.headline}</p>
                </div>
                <div className="mt-auto pt-4 border-t border-stone-100 flex items-center justify-between">
                  <span className="inline-block px-4 py-2 bg-orange-500 text-white text-xs font-bold rounded-lg whitespace-nowrap">
                    {ex.cta}
                  </span>
                  <span className="text-xs font-semibold text-green-600 bg-green-50 border border-green-100 rounded-full px-3 py-1">
                    {ex.result}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <p className="text-center text-sm text-stone-400 mt-8">
          AdForge also works for brokerages, property managers, mortgage brokers, and new development sales.{' '}
          <a href="/signup" className="text-orange-500 font-semibold hover:underline">Try it free →</a>
        </p>
      </div>
    </section>
  );
}
